import React from "react";
import { useIntl } from "react-intl";

import TooltipButton from "../../tooltipButton";

const FilterButton = ({ showFilter, onClick }) => {
  const intl = useIntl();
  return (
    <TooltipButton
      text={intl.formatMessage({
        id: "messages.filter",
        defaultMessage: "Filtr",
      })}
      onClick={onClick}
      className="header-button-margin"
      icon={showFilter ? "down" : "up"}
    />
  );
};

export default FilterButton;
